/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IGeneraProductApplicationViewProps } from './genera-product-application';

import { ArrayExtensions, ObjectExtensions } from '@msdyn365-commerce-modules/retail-actions';
import { Module, Node } from '@msdyn365-commerce-modules/utilities';

const ProductApplicationView: React.FC<IGeneraProductApplicationViewProps> = props => {
    const { ProductSpecification, ProductSpecificationTableProps, ProductSpecificationTableBodyProps, productSpecificationResult, ProductSpecificationTableHeadProps, productApplicationTableHead } = props;
    const rowdata = productSpecificationResult &&
        ArrayExtensions.hasElements(productSpecificationResult) &&
        productSpecificationResult.filter((row) => !ObjectExtensions.isNullOrUndefined(row));

    return (
        rowdata && ArrayExtensions.hasElements(rowdata) ? (
            <Module {...ProductSpecification}>
                {props.title}
                <Node {...ProductSpecificationTableProps}>
                    <Node {...ProductSpecificationTableHeadProps}>
                        {productApplicationTableHead}
                    </Node>
                    <Node {...ProductSpecificationTableBodyProps}>
                        {rowdata}
                    </Node>
                </Node>
            </Module>) : null
    );
};


export default ProductApplicationView;